import React, { useReducer, useEffect } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { MenuItem, Dropdown } from 'react-bootstrap';

import ProfileImage from 'components/elements/molecules/Images/profileImage';
import { Icon, ICONS } from 'components/Icons';
import * as Actions from 'redux/actions/index';
import InteractionReviews from './InteractionReview';
import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';

import './QTPCard.scss';

const surveyKeys = ['why', 'whatsYourTake'];
const somethingElseKeys = {
  why: 'otherReasonWhy',
  whatsYourTake: 'otherReasonWhatsYourTake',
};

function QTPCard({
  qtp,
  className,
  onUpdate,
  user,
  point,
  collection,
  openShareModal,
  rid,
  courseId,
  actions,
  teacherMode,
}) {
  const [state, dispatch] = useReducer(
    (state, action) => {
      switch (action.type) {
        case 'TOGGLE_MENU':
          return { ...state, showMenu: !state.showMenu };
        default:
          return state;
      }
    },
    { showMenu: false },
  );

  useEffect(() => {
    if (qtp.interactionReviews) {
      return;
    }

    actions.getInteractionReviews(qtp, 'QTP', point);
    // eslint-disable-next-line
  }, [qtp]);

  function onShare() {
    const url = `${window.location.origin}/collection/${collection._id}?claimId=${point._id}&claimQTPId=${qtp._id}`;
    const model = {
      shareUrl: url,
      iframeUrl: url,
      directLink: url,
      mediumUrl: url,
    };
    openShareModal(model, 'Question');
  }

  function renderUpdateMyQuestionMenuItem() {
    if (!onUpdate || user.user._id !== qtp.userId) {
      return null;
    }

    if (rid) {
      if (rid !== qtp.surveyResponse.rid) {
        return null;
      }
    } else if (user.user._id !== qtp.userId) {
      return null;
    }

    return (
      <MenuItem onClick={() => onUpdate(qtp)} bas>
        <Icon icon={ICONS.QUESTION} className="mr-3" />
        Update my Question
      </MenuItem>
    );
  }

  function renderMenu() {
    if (!point && !collection) {
      return null;
    }

    return (
      <Dropdown
        pullRight={true}
        className="more-menu ml-auto"
        onClick={(e) => e.stopPropagation()}
        onToggle={() => dispatch({ type: 'TOGGLE_MENU' })}
        id="qtp-card-dropdown"
        open={state.showMenu}
      >
        <Dropdown.Toggle noCaret aria-label="More options">
          <Icon icon={ICONS.MORE} />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {renderUpdateMyQuestionMenuItem()}
          <MenuItem onClick={onShare}>
            <Icon icon={ICONS.SAVE_1} className="mr-3" />
            Share
          </MenuItem>
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  function renderHeader() {
    return (
      <div className="d-flex align-items-center">
        <ProfileImage
          username={qtp.user ? qtp.user.username : ''}
          userId={qtp.userId}
          allowUserToChangePic={false}
          allowClickToPortfolio={false}
          size={24}
        />
        <div className="ml-3 font-weight-600 gray-3 font-size-12">
          {qtp.userId === user.user._id
            ? 'You questioned this Point'
            : 'Questioned this Point'}
        </div>
        {renderMenu()}
      </div>
    );
  }

  function renderSurveyItem(text, key) {
    return (
      <div className="d-flex align-items-center mt-2" key={key}>
        <div
          className="av-medium-blue flex-shrink-0 justify-content-center d-inline-flex align-items-center"
          style={{ width: '24px' }}
        >
          <Icon icon={ICONS.CHECK} size={16} />
        </div>
        <div className="ml-3">{text}</div>
      </div>
    );
  }

  function renderCaptions() {
    const { surveyResponse } = qtp;

    if (!surveyResponse.captions || !surveyResponse.captions.length) {
      return null;
    }

    return (
      <div className="captions">
        ...
        {surveyResponse.captions.map((caption) => (
          <span>{caption.text}</span>
        ))}
        ...
      </div>
    );
  }

  function renderSurvey() {
    const surveyResponse = qtp.surveyResponse || {};

    if (!Object.keys(surveyResponse).length) {
      return null;
    }

    const items = Object.keys(surveyResponse)
      .filter((i) => surveyKeys.indexOf(i) !== -1)
      .map((key) => {
        let value = surveyResponse[key];

        if (value.toLowerCase() === 'something else') {
          const otherReason = surveyResponse[somethingElseKeys[key]];

          if (otherReason) {
            value += ` : ${otherReason}`;
          }
        }

        return renderSurveyItem(value, key);
      });
    return <div className="">{items}</div>;
  }

  function renderUpdateMyQuestionBtn() {
    if (!onUpdate || user.user._id !== qtp.userId) {
      return null;
    }

    return (
      <div className="d-flex align-items-center justify-content-center mt-3">
        <RectangularButton
          onClick={() => onUpdate(qtp)}
          className="font-size-12"
        >
          Update my Question
        </RectangularButton>
      </div>
    );
  }

  function renderInteractions() {
    // if (!courseId) {
    //   return null;
    // }

    return (
      <InteractionReviews
        interactionId={qtp._id}
        interactionType="QTP"
        courseId={courseId}
        actions={actions}
        interactionReviews={qtp.interactionReviews}
        user={user}
        interaction={qtp}
        point={point}
        teacherMode={teacherMode}
      />
    );
  }

  const containerClassName = classnames('qtp-card p-3', className);
  return (
    <div className={containerClassName}>
      {renderHeader()}
      {renderCaptions()}
      {renderSurvey()}
      {renderUpdateMyQuestionBtn()}
      {renderInteractions()}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
    openShareModal: (model, type) => {
      const props = { model, type };
      dispatch(Actions.openModal('Share', props));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(QTPCard);
